module.exports = __webpack_public_path__ + "img/activityIcon.0e79b58.png";